import { createReducer, on } from '@ngrx/store';
import { SearchResult } from '../../models';
import * as pageActions from '../actions/search-results.action';

export interface SearchResultsState {
  entities: { [contentType: string]: SearchResult[] };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: SearchResultsState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const SearchResultsReducer = createReducer(
  initialState,
  on(pageActions.LoadSearchResults, (state: SearchResultsState) => {
    return {
      ...state,
      entities: {},
      loading: true,
      loaded: false,
    };
  }),
  on(pageActions.LoadSearchResultsSuccess, (state: SearchResultsState, { results }) => {
    // Group results by contentType. Sort the results by relevance
    const entities = groupAndSortByContentType(results);

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadSearchResultsFail, (state: SearchResultsState, { error }) => {
    return {
      ...state,
      entities: {},
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getSearchResultsEntities = (state: SearchResultsState) => state.entities;
export const getSearchResultsLoading = (state: SearchResultsState) => state.loading;
export const getSearchResultsLoaded = (state: SearchResultsState) => state.loaded;

function groupAndSortByContentType(results: SearchResult[]): { [contentType: string]: SearchResult[] } {
  return results.reduce(
    (acc, result) => {
      // Ensure there's a group for the current contentType
      if (!acc[result.contentType]) {
        acc[result.contentType] = [];
      }

      // Add the result to the appropriate group
      acc[result.contentType].push(result);

      // Sort the group by relevance (descending order)
      acc[result.contentType].sort((a: SearchResult, b: SearchResult) => b.relevance - a.relevance);

      return acc;
    },
    {} as { [contentType: string]: SearchResult[] }
  );
}
